import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { CreateEstagioEventoDto, ResponseEstagioDto, ResponseEstagioEventoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindEstagioEventoDto } from '@/api.types.extra';

const endpoint2 = Endpoints.ESTAGIO_EVENTOS;

export async function listarEstagios(idEstagiario: number) {
  return api
    .get(Endpoints.ESTAGIO + '/lista/' + idEstagiario)
    .then((response) => {
      return GetApiReturn<ResponseEstagioDto>(response.data as Array<ResponseEstagioDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ResponseEstagioDto>(error, 'Falha ao listar Estágios.');
      return GetApiReturnError<ResponseEstagioDto>();
    });
}

export async function listarEventosEstagio(params: FindEstagioEventoDto): Promise<ResponseEstagioEventoDto[]> {
  try {
    const response = await api.get(`${endpoint2}`, { params: params });
    return response.data[0] || [];
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao listar eventos do estágio.');
  }
}

export async function criarEventoEstagio(dto: CreateEstagioEventoDto): Promise<number> {
  try {
    const response = await api.post(`${endpoint2}`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao criar evento de estágio.');
  }
}

export async function atualizarEventoEstagio(id: number, dto: Partial<CreateEstagioEventoDto>): Promise<void> {
  try {
    await api.put(`${endpoint2}/${id}`, dto);
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar evento de estágio.');
  }
}

export async function excluirEventoEstagio(id: number): Promise<void> {
  try {
    await api.delete(`${endpoint2}/${id}`);
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao excluir evento de estágio.');
  }
}